import React from 'react'
import { Link } from 'react-router-dom'
import { GO_BACK, HOME, OOPS, PAGE_NOT_FOUND } from '../../translations/en/en'

export const NotFound = ({ title }) => {

  return (
    <section className="check-out osahan-home-page static-page-mt" style={{ height: "100vh" }}>
      <div className="container h-100">
        <div className="check-out-container d-flex justify-content-center align-items-center">
          <div className=''>
            <div className='mb-5'>
              <h4>{OOPS}</h4>
              <h4>{title?title:PAGE_NOT_FOUND}</h4>
            </div>
              <div>
                <Link to={-1} className="btn border-yellow text-yellow font-weight-800 font-size-14 border-radius-5 py-2">{GO_BACK}</Link>
                <Link to="/" className="btn border-yellow text-yellow font-weight-800 font-size-14 border-radius-5 py-2 mx-4">{HOME}</Link>
              </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NotFound
